export interface BaseEntityOption {
  id: number;
  name: string;
  isSelected?: boolean;
}

export interface ContactOption extends BaseEntityOption {
  title: string;
  company: string;
  phone: string;
  phoneId?: number;
  email: string;
}

export interface DealOption extends BaseEntityOption {
  dealType: string;
  propertyType: string;
  stage: string;
  entryDate: string;
  rmsExternalIds: string[];
}

export interface PropertyOption extends BaseEntityOption {
  address: string;
  city: string;
  state: string;
  propertyType: string;
  // assetMeasurements: AzureIndexMeasurementModel[];
}

export interface CompanyOption extends BaseEntityOption {
  primaryAddress: string;
  hasHighlights?: boolean;
}
export enum GlobalSearchCategory {
  Global = 0,
  Company = 1,
  Contact = 2,
  Deal = 3,
  Property = 4,
}
export interface SearchCategory {
  id: number;
  name?: GlobalSearchCategory;
  displayName: string;
}
export const searchCategories: SearchCategory[] = [
  { id: GlobalSearchCategory.Global, displayName: 'All' },
  { id: GlobalSearchCategory.Contact, displayName: 'Contacts' },
  { id: GlobalSearchCategory.Company, displayName: 'Companies' },
  { id: GlobalSearchCategory.Deal, displayName: 'Deals' },
  { id: GlobalSearchCategory.Property, displayName: 'Properties' },
];

export interface GlobalEntitySearchPayload {
  type: GlobalSearchCategory;
  search: string;
  take: number;
  parentsOnly?: boolean;
}

export interface GlobalEntitySearchResults {
  contactOptions: ContactOption[];
  contactsTotal: number;
  companyOptions: CompanyOption[];
  companiesTotal: number;
  dealOptions: DealOption[];
  dealsTotal: number;
  propertyOptions: PropertyOption[];
  propertiesTotal: number;
}

export const resultsCountText = (total = 0) => (
  `${total} result${total === 1 ? '' : 's'}`
);
